import React from 'react';
import { BsFillUnlockFill } from 'react-icons/bs';
import { FaGlobeAmericas, FaPhone, FaUser } from 'react-icons/fa';
import { MdGpsFixed } from 'react-icons/md';
import { VscLoading } from 'react-icons/vsc';

const ChatMentionRenderSuggestion = (suggestion, search, highlightedDisplay, index, focused) => {
    const { type, id, contact } = suggestion;
    if (id === 'loading') {
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px',
                    pointerEvents: 'none',
                    userSelect: 'none',
                }}
            >
                <VscLoading className="spin" style={{ marginRight: '8px' }} />
                <span>Searching...</span>
            </div>
        );
    }
    let icon = <FaUser style={{ marginRight: '8px' }} />;
    if (contact) {
        icon = <FaPhone style={{ marginRight: '8px' }} />;
    }
    if (type) {
        icon = <FaGlobeAmericas style={{ marginRight: '8px' }} />;
        if (type === 'private') icon = <BsFillUnlockFill style={{ marginRight: '8px' }} />;
        if (type === 'gps_enabled') icon = <MdGpsFixed style={{ marginRight: '8px' }} />;
    }
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {icon}
            {highlightedDisplay}
        </div>
    );
};
export default ChatMentionRenderSuggestion;
